import React from "react";
import PropTypes from "prop-types";

import Card from "components/Card";
import MoneyInput from "components/MoneyInput";
import AddButton from "components/school_money/AddButton";

import "./CreditTopUp.css";

export default class CreditTopUp extends React.Component {
  
  static propTypes = {
    defaultAmount: PropTypes.number,
    onAddToBasket: PropTypes.func.isRequired
  }
  
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.amount === undefined) {
      return {
        amount: nextProps.defaultAmount
      }
    }
    return null;
  }
  
  state = {
    amount: undefined,
    isInputValid: true
  }
  
  validateInput = amount => {
    return amount > 0;
  }
  
  onChange = amount => {
    this.setState({ amount });
  }
  
  onInputValidityChange = isInputValid => {
    this.setState({ isInputValid });
  }
  
  onAddToBasket = () => {
    if (this.state.isInputValid) {
      this.props.onAddToBasket(this.state.amount);
    }
  }
  
  render() {
    const { defaultAmount, label } = this.props;
    
    const classNames = [ "credit-top-up" ];
    if (!this.state.isInputValid) {
      classNames.push("credit-top-up--invalid");
    }
    
    return (
      <div className={classNames.join(" ")}>
        <Card>
          <Card.Body>
            <div className="credit-top-up__body">
              <MoneyInput
                className="credit-top-up__input"
                initialAmount={defaultAmount}
                defaultAmount={defaultAmount}
                amount={this.state.amount}
                onChange={this.onChange}
                validateInput={this.validateInput}
                onValidityChange={this.onInputValidityChange}
              />
              <div className="credit-top-up__label">{label}</div>
              <AddButton className="credit-top-up__add-button" onClick={this.onAddToBasket} />
            </div>
          </Card.Body>
        </Card>
      </div>
    )
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/CreditTopUp.js